/* eslint-disable no-unused-vars */
/**
 * @Description File generated by awesome-react-template
 * @FileName App.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 08 January, 2021 14:23:08
 * @IssueID - 459, 305, 311
 */
import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { LANG, MuxProvider } from '@manulife/mux';
import i18n from './app/common/i18n';
import { Layout } from './app/common/components/masterPage';
import FasatLoader from './app/common/components/fasatLoader/fasatLoader';
import getMenuItems from './config/menuConfig';
import FasatRouter from './fasatRouter';
import { IsACLEnabled } from './app/common/util/utility';
import { getAllQuicksLinks } from './app/common/redux/actions/commonActions';
import SkipLinks from './app/common/aodalink/SkipLinks';

function App() {
  const [menuItems, setMenuItems] = useState([]);
  const [locale, setLocale] = useState(i18n.language || 'en');

  /**
   * Subscribe to i18n language change events to trigger App re-render.
   * This ensures MuxProvider receives updated lang prop when language changes,
   * which is required for MUX components (like LangButton) that use useLang() hook
   * to correctly toggle between languages on subsequent clicks.
   * Without this, MuxProvider's lang prop would remain stale after i18n.changeLanguage().
   */
  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLocale(lng);
    };
    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  window.addEventListener('popstate', (_e) => {
    window.history.pushState(null, '', window.location.origin);
  });

  const dispatch = useDispatch();
  const processingInProgress = useSelector(
    ({ ApplicationStateFilterList }) => ApplicationStateFilterList.processingInProgress,
  );
  const rbacData = useSelector(({ ApplicationStateRBAC }) => ApplicationStateRBAC.rbacData);
  const loggedUser = useSelector(({ ApplicationStateRBAC }) => ApplicationStateRBAC.loggedUser);
  const isBatchProcessing = useSelector(({ ApplicationState }) => ApplicationState.isBatchProcessing);
  useEffect(() => {
    if (loggedUser && rbacData?.access?.length > 0) {
      dispatch(getAllQuicksLinks(loggedUser));
      const rbacMenus = getMenuItems().filter((item) => IsACLEnabled(rbacData, item, loggedUser));
      setMenuItems(rbacMenus);
    } else {
      setMenuItems([]);
    }
  }, [rbacData, loggedUser, locale, isBatchProcessing]);
  return (
    <main>
      <div className="App" data-testid="FASAT_APP">
        <SkipLinks />
        {processingInProgress > 0 && <FasatLoader />}
        <div>
          <I18nextProvider i18n={i18n}>
            <MuxProvider langProvider={{ lang: locale === 'en' ? LANG.EN_CA : LANG.FR_CA }}>
              <Router>
                <Layout menuItems={menuItems} mobileMenuTabs={[]} selectedTab={null}>
                  <FasatRouter isBatchProcessing={isBatchProcessing} loggedUser={loggedUser} menuItems={menuItems} />
                </Layout>
              </Router>
            </MuxProvider>
          </I18nextProvider>
        </div>
      </div>
    </main>
  );
}
export default App;
